import { Component, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';

@Component({
	selector: 'app-date-picker-control',
	standalone: true,
	imports: [ReactiveFormsModule, NzFormModule, NzDatePickerModule],
	templateUrl: './date-picker-control.html',
})
export class DatePickerControl {
	label = input.required<string>();
	controlName = input.required<string>();
	placeholder = input<string>('');
	required = input<boolean>(true);
	formGroup = input.required<FormGroup>();
}
